import { INSTANCE_TOKEN, IOS_TOKEN } from "../common";
import { isBrowser, isElectron } from 'react-device-detect';
import { getLocalStorage } from "../common";

export const showMessage = (msg) => {
}

export const closeAlert = () => {
    return null
}

export const webNotifFunc = async (fcm_messages) => {
    try {
        if (Notification.permission !== 'granted') {
            await Notification.requestPermission().then((permission) => {
            });
            await fcm_messages.requestPermission();
        }

        const token = await fcm_messages.firebaseDependencies.installations.getToken();

        if (getLocalStorage(INSTANCE_TOKEN) !== token) {
            localStorage.setItem(INSTANCE_TOKEN, token);
        }            
    } catch (e) {
        let _emsg = '';

        if (e.hasOwnProperty('code') && e.code === 'messaging/permission-default') {
            _emsg = 'You need to allow the site to send notifications';
        } else if (e.hasOwnProperty('code') && e.code === 'messaging/permission-blocked') {
            _emsg = 'Currently, the site is blocked from sending notifications. \nPlease unblock the same in your browser settings';
        } else {
            _emsg = 'Unable to subscribe you to notifications';
        }

        if (navigator.notification) {
            navigator.notification.alert(
                _emsg, 
                closeAlert, 
                'Error', 
                'Close'
            );
        } else {
        }
    }

    return navigator.serviceWorker.addEventListener("message", ({data}) => {
        showMessage(data);
    });
}

export const iosNotifFunc = () => {
    try {
        if (window.FCMPlugin) {
            window.FCMPlugin.getToken(function(fcmToken){
                localStorage.setItem(INSTANCE_TOKEN, fcmToken);
            });

            window.FCMPlugin.onTokenRefresh(function(fcmToken){
                localStorage.setItem(INSTANCE_TOKEN, fcmToken);
            });

            window.FCMPlugin.onNotification(function(data){
                if(data.wasTapped){
                } else {
                }
            });

        } else if (window.FirebasePlugin) {
        }
        
    } catch (e) {
        let _emsg = 'Firebase not avaiable...';
        if (navigator.notification) {
            navigator.notification.alert(
                _emsg, 
                closeAlert, 
                'Error', 
                'Close'
            );
        } else {
        }
    } 
}

export const androidNotifFunc = () => {
    try {
        if (window.FCMPlugin) {
            window.FCMPlugin.getToken(function(fcmToken){
                localStorage.setItem(INSTANCE_TOKEN, fcmToken);
            });

            window.FCMPlugin.onTokenRefresh(function(fcmToken){
                localStorage.setItem(INSTANCE_TOKEN, fcmToken);
            });

            window.FCMPlugin.onNotification(function(data){
                if(data.wasTapped){
                } else {
                }
            });
        } else if (window.FirebasePlugin) {
        }            
    } catch (e) {
        let _emsg = 'Firebase not avaiable...';
        if (navigator.notification) {
            navigator.notification.alert(
                _emsg, 
                closeAlert, 
                'Error', 
                'Close'
            );
        } else {
        }
    } 
}

export const setContainer = (bool) => {
    return { padding: "0 16px 32px", margin: "calc(56px + env(safe-area-inset-top)) 0px 64px", width: "calc(100% - 32px)", overflowY: "auto", overflowZ: "hidden"};

    if (bool) {
        if (isBrowser && !isElectron) {
            return { padding: "0 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto" };
        } else {
            return { padding: "0 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto" };
        }
        
    } else {
        if (isBrowser && !isElectron) {
            return { padding: "0 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto" };
        } else {
            return { padding: "0 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto" };
        }
    }
}